export const DEFAULT_DATA_VERSION = "latest";

let cachedVersion: string | null = null;

export function resolveVersionFromHash(hash: string, fallback = DEFAULT_DATA_VERSION): string {
  const match = hash.match(/[?&]dataVer=([^&]+)/);

  if (!match) {
    return fallback;
  }

  return decodeURIComponent(match[1]);
}

export function resolveVersion(): string {
  if (cachedVersion !== null) {
    return cachedVersion;
  }

  cachedVersion = resolveVersionFromHash(window.location.hash);

  return cachedVersion;
}
